import { CheckOutlined } from "@ant-design/icons";
import { Flex, Grid, Radio } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { useLayout } from "../../context/LayoutContext";
import { P1 } from "../NormalFonts";
import SkeletonTabs from "../SkeletonTabs";
import { CustomRadioButtonProps } from "./data";
import { ALL_KEY } from "./enumerations/enumerations";
import styles from "./styles.module.scss";
import "./styles.scss";

const CustomRadioButton: React.FC<CustomRadioButtonProps> = ({
  items,
  selectedValue,
  onValueChange,
  loading = false,
  centered = false,
  wrapperStyle = "",
}) => {
  const { t } = useTranslation();
  const { getMargin } = useLayout();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  return (
    <div
      className={`${wrapperStyle} ${styles.categoryWrapper}`}
      style={{
        marginLeft: `${getMargin()}`,
        marginRight: `${getMargin()}`,
      }}
    >
      {loading ? (
        <SkeletonTabs centered={centered} />
      ) : (
        <div
          className="custom-radio"
          style={{
            width: "max-content",
            paddingLeft: `calc(${getMargin()} * -1)`,
            paddingRight: `calc(${getMargin()} * -1)`,
          }}
        >
          <Radio.Group value={selectedValue} onChange={onValueChange}>
            <Radio.Button value={ALL_KEY}>
              <Flex gap={8}>
                {selectedValue === ALL_KEY && <CheckOutlined />}
                <P1 weight="medium">{t("coaches.all")}</P1>
              </Flex>
            </Radio.Button>
            {items?.map((item: any, index: number) => (
              <Radio.Button value={item.value} key={index}>
                <Flex gap={8}>
                  {selectedValue === item.value && <CheckOutlined />}
                  <P1 weight="medium">{item.label}</P1>
                </Flex>
              </Radio.Button>
            ))}
          </Radio.Group>
        </div>
      )}
    </div>
  );
};

export default CustomRadioButton;
